import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {CkmService} from "../../../services/ckm.service";
import {HeaderTitleService} from "../../../services/general/header-title.service";
import {TranslateService} from "@ngx-translate/core";
import * as go from 'gojs';
import {ModalSurveyDetailsComponent} from "../../../modals/modal-survey-details/modal-survey-details.component";
import {MatDialog} from "@angular/material/dialog";
import {ModalResetPasswordComponent} from "../../../modals/modal-reset-password/modal-reset-password.component";
import {CkmModalEntityDetailsComponent} from "../ckm-modal-entity-details/ckm-modal-entity-details.component";

@Component({
  selector: 'app-ckm-map-details',
  templateUrl: './ckm-map-details.component.html',
  styleUrls: ['./ckm-map-details.component.scss']
})
export class CkmMapDetailsComponent implements OnInit {
  mapID = null;
  map = null;
  loading = false;
  public diagram: go.Diagram;
  attachments = null;
  project_id = null;
  tmp = null;
  aiAnalysisShowed = false;

  displayedColumns: string[] = ['action', 'responsible', 'startDate', 'endDate', 'progress', 'aiSuggestion'];
  dataSource = [
    {
      action: 'Information Operations Counter-Disinformation Campaign',
      responsible: 'Information Warfare Cell – NATO StratCom',
      startDate: '17-04-2024',
      endDate: '26-04-2024',
      progress: 68,
      aiSuggestion: 'Urgent reassessment (68%) [!]'
    },
    {
      action: 'Secure Communications Systems Deployment',
      responsible: 'Secure C2 Command',
      startDate: '22-04-2024',
      endDate: '04-05-2024',
      progress: 94,
      aiSuggestion: 'Continue plan (94%) [✓]'
    },
    {
      action: 'Logistical Support Sustainment Operations',
      responsible: 'Joint Logistics Division',
      startDate: '15-04-2024',
      endDate: '30-04-2024',
      progress: 87,
      aiSuggestion: 'Continue plan (87%) [✓]'
    },
    {
      action: 'Surveillance Reconnaissance Enhancement',
      responsible: 'ISR Coordination Center',
      startDate: '26-04-2024',
      endDate: '10-05-2024',
      progress: 72,
      aiSuggestion: 'Early review recommended (72%) [i]'
    }
  ];


  constructor(
    private route: ActivatedRoute,
    private ckmService: CkmService,
    private headerService: HeaderTitleService,
    private translateService: TranslateService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.mapID = this.route.snapshot.paramMap.get('map-id');
    this.init();
  }

  init() {
    this.loading = true;
    this.ckmService.getCkmMapDetails(this.mapID, (response) => {
      this.map = response;
      this.loading = false;
      this.tmp = {
        events: this.map.events.map((event) => {
          return {id: event.id, title: event.event.name}
        }),
        actions: this.map.actions.map((action) => {
          return {id: action.id, title: action.action.name}
        }),
        impact_factors: this.map.impact_factors.map((impact_factor) => {
          return {
            id: impact_factor.id,
            source_type: impact_factor.impact_factor.source_type,
            target_type: impact_factor.impact_factor.target_type,
            source: impact_factor?.impact_factor.source.name,
            target: impact_factor?.impact_factor.target.name,
          }
        }),
      };
      this.ckmService.getCkmSimulationDetails(response.ckm_simulation_id, (response) => {
        this.attachments = response?.attachment_pubmeds?.concat(response?.attachment_files)?.map((file) => file?.link) || [];
        this.project_id = response.organization_project_id
      });
      this.headerService.setTitle(this.translateService.instant("generic.map") + " v" + this.map.version);
      this.initDiagram();
    }, (error) => {
      this.loading = false;
    });
  }

  initDiagram(): void {
    this.diagram = new go.Diagram("myDiagramDiv");

    this.diagram.nodeTemplate =
      go.GraphObject.make(go.Node, "Auto",
        go.GraphObject.make(go.Shape, "RoundedRectangle",
          {strokeWidth: 0, fill: "lightblue"},
          new go.Binding("fill", "color")),
        go.GraphObject.make(go.TextBlock,
          {margin: 8, font: "bold 12px sans-serif"},
          new go.Binding("text", "name"))
      );

    this.diagram.linkTemplate =
      go.GraphObject.make(go.Link,
        {routing: go.Link.AvoidsNodes, curve: go.Link.JumpOver},
        go.GraphObject.make(go.Shape),
        go.GraphObject.make(go.Shape, {toArrow: "Standard"}),
        go.GraphObject.make(go.TextBlock,
          {segmentOffset: new go.Point(0, -10), font: "10px sans-serif"},
          new go.Binding("text", "weight"))
      );

    const nodes = [];

    if (this.map.actions) {
      this.map.actions.forEach((a: any) => {
        nodes.push({
          key: `action-${a.action.id}`,
          name: a.action.name,
          type: "action",
          description: a.action.description,
          color: "lightgreen"
        });
      });
    }

    if (this.map.events) {
      this.map.events.forEach((e: any) => {
        nodes.push({
          key: `event-${e.event.id}`,
          name: e.event.name,
          type: "event",
          description: e.event.description,
          color: "lightcoral"
        });
      });
    }

    const actionsMap: { [key: number]: string } = {};
    this.map.actions.forEach((a: any) => {
      actionsMap[a.action.id] = `action-${a.action.id}`;
    });
    const eventsMap: { [key: number]: string } = {};
    this.map.events.forEach((e: any) => {
      eventsMap[e.event.id] = `event-${e.event.id}`;
    });


    const links = [];
    if (this.map.impact_factors) {
      this.map.impact_factors.forEach((ifItem: any) => {
        const impactFactor = ifItem.impact_factor;
        let fromKey = "";
        let toKey = "";
        if (impactFactor.source_type === "action") {
          fromKey = actionsMap[impactFactor.source_id];
        } else if (impactFactor.source_type === "event") {
          fromKey = eventsMap[impactFactor.source_id];
        }
        if (impactFactor.target_type === "action") {
          toKey = actionsMap[impactFactor.target_id];
        } else if (impactFactor.target_type === "event") {
          toKey = eventsMap[impactFactor.target_id];
        }
        if (fromKey && toKey) {
          links.push({
            from: fromKey,
            to: toKey,
            weight: ifItem.weight.toString()
          });
        }
      });
    }

    this.diagram.model = new go.GraphLinksModel(nodes, links);

    this.diagram.layout = go.GraphObject.make(go.TreeLayout, {
      layerSpacing: 100,     // Spazio tra i livelli
      nodeSpacing: 100       // Spazio tra i nodi adiacenti
    });
  }

  viewActionDetails(action) {
    this.viewEntityDetails(action, 'action');
  }

  viewEventDetails(event) {
    this.viewEntityDetails(event, 'event');
  }

  showAIAnalysis() {
    this.aiAnalysisShowed = true;
  }

  viewImpactFactorDetails(impact_factor) {
    this.viewEntityDetails(impact_factor, 'impact_factor');
  }

  viewEntityDetails(entity, type) {
    const dialogRef = this.dialog.open(CkmModalEntityDetailsComponent, {
      panelClass: 'fullscreen-dialog',
      data: {
        type,
        entity
      }
    })

    dialogRef.afterClosed().subscribe((result) => {

    });
  }


  addNewSurvey() {
    const dialogRef = this.dialog.open(ModalSurveyDetailsComponent, {
      panelClass: 'fullscreen-dialog',
      disableClose: true,
      data: {
        projectId: this.project_id,
        ckm_map_id: this.map.id
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== null && result !== undefined && result?.id) {
        this.map.survey_id = result.id
      }
    });
  }
}
